import React, { useContext } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { Section } from '../../types/puppyGuide';
import AnalyticsContext from '../../context/AnalyticsContext';
import { ANALYTICS_ACTION_CLICK, ANALYTICS_LABEL_SUFFIX_HEADER } from '../../AnalyticsProvider';
import { imgPath } from './constants';
import { usePuppyGuide } from './PuppyGuideContext';
import './nav-items.scss';

const NavItems = ({ t }: { t: TFunction<string> }) => {
  const { refSections, handleSelectSection } = usePuppyGuide();
  const handleOnClick = (index: number) => {
    const refItem = refSections[index];
    handleSelectSection(refItem);
  };
  const analytics = useContext(AnalyticsContext);
  return (
    <nav className="nav-items" aria-label="Sub">
      {t<string, Section[]>('puppyGuide.sections', { returnObjects: true }).map((item, index) => (
        <button
          tabIndex={0}
          className={`nav-items__item nav-items__item--${index + 1}`}
          onClick={(e) => {
            e.preventDefault();
            analytics.trackStarterGuide(
              ANALYTICS_ACTION_CLICK,
              `${item.title}${ANALYTICS_LABEL_SUFFIX_HEADER}`,
            );
            handleOnClick(index);
          }}
          key={index}
        >
          <div>
            <img
              className="nav-items__img"
              src={`${imgPath}${item.images.nav.src}`}
              alt={item.images.nav.alt}
            />
          </div>
          <div>
            <div className="nav-items__title">
              {index + 1}. {item.title}
            </div>
            <div>{item.subtitle}</div>
          </div>
        </button>
      ))}
    </nav>
  );
};

export default withTranslation()(NavItems);
